// extracted by mini-css-extract-plugin
export default {"container":"OfferCatalog_container__-CFhh","buttonWrapper":"OfferCatalog_buttonWrapper__0XOi6","box":"OfferCatalog_box__22ZkG"};